import * as ActionTypes from 'state/actions/types'
import moment from 'moment'
import moveDateRangeToCustom from 'shared/utils/chart/moveDateRangeToCustom'

const initialState = {
  chartType: 'bar',
  granularity: 'day',
  dateRange: 'This month',
  channelNameToFilter: 'all',
  customDateRange: {
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month')
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.RESOLVED_BY_BOT_CHANGE_FIELD: {
      return {
        ...state,
        [action.field]: action.value
      }
    }

    case ActionTypes.RESOLVED_BY_BOT_CHANGE_CUSTOM_DATE_RANGE: {
      if(!action.startDate || !action.endDate) {
        return {
          ...state
        }
      }

      // console.log(action.endDate.diff(action.startDate, 'days'))
      return {
        ...state,
        customDateRange: {
          startDate: action.startDate,
          endDate: action.endDate
        }
      }
    }

    case ActionTypes.RESOLVED_BY_BOT_MOVE_CUSTOM_DATE_RANGE: {
      const momentDateRange = state.dateRange === 'custom'
        ? state.customDateRange
        : moveDateRangeToCustom(state.dateRange)

      const {
        startDate,
        endDate
      } = momentDateRange

      const differenceInDays = endDate.diff(startDate, 'days')

      let newStartDate,
          newEndDate

      if(action.operation === 'forward') {
        newStartDate = startDate.add(differenceInDays, 'days')
        newEndDate = endDate.add(differenceInDays, 'days')
      } else {
        newStartDate = startDate.add(-differenceInDays, 'days')
        newEndDate = endDate.add(-differenceInDays, 'days')
      }

      return {
        ...state,
        dateRange: 'custom',
        customDateRange: {
          startDate: newStartDate,
          endDate: newEndDate
        }
      }
    }

    default: {
      return state
    }
  }
}
